var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-train color-3 font-weight-light",style:(`
    ${_vm.shadow ? 'box-shadow: 0 -5px 5px -5px #000000;' : ''}
    ${_vm.no_margin_top ? 'margin-top: 3px' : ''}
    ${_vm.getUseOnSite ? 'min-height: 98px;' : 'min-height: 40px;'}
  `)},[_c('div',{staticClass:"wallet-train-name-slot"},[_vm._t("name",null,{"wallet_settings":_vm.wallet_settings})],2),_vm._t("content",null,{"wallet_settings":_vm.wallet_settings,"step_cards":_vm.step_cards})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }